<template>
  <div style="max-width: 105rem; margin: auto" class="full-height">
    <header class="flex">
      <div class="flex items-center logo-container">
        <a class="ucpa-logo ml3" :href="$store.getters.alphaURL">
          <svg
            id="logo-ucpa"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <!-- eslint-disable max-len -->
            <path
              d="M94.3 197.1v69.7c0 20.3-5.6 33.5-27.4 33.5s-27.7-13.2-27.7-33.5v-69.7H8.8v77c-.1 33.1 22.8 45.1 57.6 45.1 33.8 0 58.7-11.9 58.7-45.2l-.1-76.9H94.3zM444.3 195.5c-15.7 0-36.8 3.7-49.2 9l.8 22.5c11.3-7.3 23.9-12.7 43.7-12.7 26.2 0 33.6 12.3 33.6 30.2h-21.5c-15.4 0-33.6 1.1-47.7 6.7-14.1 5.7-24.3 15.9-24.3 33.3 0 21.3 18.5 34.6 44.7 34.6 15.3 0 36.3-4.8 46.8-18.3h.5c.1 3.1.5 10.9 1.6 16.7h29.8l.1-77.8c-2.6-31.2-17.4-44.2-58.9-44.2zm-8.4 104.8c-12.8.2-23.5-5.8-23.5-17.8 0-17.5 17.8-21.3 39.3-21.3h21.5c0 25.5-17.4 38.7-37.3 39.1zM216.9 295.5c-27.2 0-42.5-19.3-42.5-41.9 0-21.2 13.3-41.4 41.9-41.4 10.2 0 19.3 1.3 31.7 6.2l.8-20.8c-11-3.2-23.2-4.8-32.5-4.8-44.8 0-74.2 21.6-74.2 62.5 0 36.4 28.7 58.5 74.2 58.5 10.8 0 21.3-1.3 33-3.7l-1-19.4c-8.2 2.8-20.2 4.8-31.4 4.8zM321.2 195.5h-54.5v118.2h31v-40.3h26.6c33.1 0 55.2-13.8 55.2-38.4.1-34.2-32.2-39.5-58.3-39.5zm.7 58.9h-24v-40.5h24c15.8 0 27.4 6.2 27.4 20.2 0 11.3-9.6 20.3-27.4 20.3z"
            />
            <!-- eslint-enable max-len -->
          </svg>
        </a>
      </div>
      <div class="flex flex-1 z4 full-height step-position">
        <StepBar
          v-if="
            (isNewTDA || isSubscriptionTDA) &&
              !isCoupeFile &&
              !isResumeOrder &&
              !isConfirmationRoute
          "
        />
      </div>
      <!-- <div class="help-title col-12 mr4 h6n right-align xs-hide"></div>
      <div class="help-title col-12 pr2 h6n right-align sm-hide md-hide lg-hide">
        <a href="tel:32 60">
          <Icon name="phone" size="20px" />
        </a>
      </div> -->
    </header>
    <div
      class="cart-body light-grey-bg"
      :class="[{ 'white-bg-mobile': isSubscriptionTDA }]"
    >
      <div class="flex flex-wrap full-height content-stretch">
        <div
          v-if="loaded"
          id="left-block"
          :style="`background-image:url(${productBackground})`"
          class="col bg-image"
        ></div>
        <div
          id="right-block"
          class="full-height light-grey-bg"
          :class="[{ 'white-bg-mobile': isSubscriptionTDA }]"
        >
          <div
            v-if="loaded"
            id="contentDiv"
            class="body-pd full-height overflow-auto"
          >
            <div
              v-if="errorMessage"
              id="errorBlock"
              class="m2 p2 white-bg flex flex-wrap justify-center"
            >
              <div class="col-12 p2 center">{{ errorMessage }}</div>
              <a
                v-if="currentRoute === 'Session'"
                class="col-6 m2 p2 red-bg center pointer"
                @click="
                  changeToPage('Calendar');
                  $store.commit('setErrorMessage', null);
                "
              >
                <span class="white btn-cta-text bold">Retour au calendrier</span>
              </a>
              <a
                v-else
                class="col-6 m2 p2 red-bg center pointer"
                @click="backToAlpha()"
              >
                <span class="white btn-cta-text bold">Retour à l'accueil</span>
              </a>
            </div>
            <router-view v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { format, fromUnixTime } from 'date-fns';
import { ref, onBeforeMount, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from '@/store/index';
import {
  getUser,
  getProduct,
  getSessionProducts,
  getOrderByUuid,
  getSessionProductsAmplify,
  getSessionById,
  getServicesProduct
} from '@/utils/requests';
import {
  changeToPage,
  handleOfferInfo,
  handleProduct,
  handleEscapeProduct,
  removeCartAndChangePage
} from '@/utils/logics';
import { moveTo404, backToAlpha, isSessionValid } from '@/utils/utils';
import StepBar from '@/components/elements/StepBar.vue';

// import Icon from '../components/elements/Icon';

const route = useRoute();
const store = useStore();
const router = useRouter();

const loaded = ref(false);

const MEDIA_URL = 'https://media.ucpa.com';
const initRouteParams = [
  {
    name: 'Home',
    params: ['product', 'offer', 'workspace']
  },
  {
    name: 'CartRecap',
    params: ['workspace']
  },
  {
    name: 'Products',
    params: [
      'activities',
      'codes',
      'start_time',
      'end_time',
      'workspace'
    ]
  }
];

const allowedInitialRoute = computed(() => [
  'Home',
  'CartRecap',
  'Confirmation',
  'Catcher',
  'Products'
].includes(route.name));

const siteInfo = computed(() => store.state.siteInfo);

const isImprovesWorkspace = computed(() => ['postgres'].includes(siteInfo.value.horanetSource));

const isAmplifyWorkspace = computed(() => siteInfo.value.is_internal_session || isImprovesWorkspace.value);

const isInternalSession = computed(() => siteInfo.value.is_internal_session);

const isResumeOrder = computed(() => route.name === 'ResumeOrder');

const isConfirmationRoute = computed(() => route.name === 'Confirmation');

const isNewTDA = computed(() => store.state.newTDA);

const isCoupeFile = computed(() => store.getters['expressCheckout/isActive']);

const isSubscriptionTDA = computed(() => store.state.subscriptionTDA);

const isInitializeRoute = computed(() => {
  const initRoute = initRouteParams.find(r => r.name === route.name);

  return initRoute ? initRoute.params.every(item => route.query.hasOwnProperty(item)) : false;
});

const productBackground = computed(() => {
  let image = '/image/upload/v1554234143/UCPA-SPORT-NATURE/France/00061752.jpg';

  const { product } = store.state;

  if (product) {
    const { header_images, headerImagesSEO, banner_image, bannerImageSEO } = product;
    if (headerImagesSEO && headerImagesSEO.length && headerImagesSEO[0].url) {
      image = `/t_UCPA_Vertical/${headerImagesSEO[0].url}`;
    } else if (bannerImageSEO && bannerImageSEO.url) {
      image = `/t_UCPA_Vertical/${bannerImageSEO.url}`;
    } else if (header_images && header_images.length) {
      image = `/t_UCPA_Vertical/${header_images[0]}`;
    } else if (banner_image) {
      image = `/t_UCPA_Vertical/${banner_image}`;
    }
  }

  return MEDIA_URL + image;
});

const errorMessage = computed(() => store.state.errorMessage);

const currentRoute = computed(() => route.name);

const cleanStateIfHome = () => {
  if (isInitializeRoute.value && allowedInitialRoute.value) {
    if (route.name !== 'Confirmation') {
      store.commit('reset');
      store.commit('expressCheckout/reset');
    }
  }
};

const handleMaintenance = () => {
  if (
    store.state.siteInfo && store.state.siteInfo.maintenance && route.name !== 'Maintenance'
  ) {
    loaded.value = true;
    return router.push({ name: 'Maintenance' });
  }
  return undefined;
};

/** Loads product + offer into the store. Returns false if product fetch fails or offer is invalid / disabled. */
const handleProductAndOffer = async (product, offerCode) => {
  try {
    const responseProduct = await getProduct({ product });
    return await handleOfferInfo(responseProduct, offerCode);
  } catch (err) {
    console.log('Error getting product', err);
    return false;
  }
};

const handleActivitiesAndSession = async (workspace, activities, codes, start_time, end_time) => {
  if (isAmplifyWorkspace.value) {
    const args = { sessions: codes, workspace: workspace };

    if (!isInternalSession.value && ['postgres'].includes(siteInfo.value.horanetSource)) {
      args.codeSiteComptage = siteInfo.value.code_site_comptage;
      args.timezone = siteInfo.value.timezone;
    }

    const { products: rawProducts, message } = await getSessionProductsAmplify(args);
    const products = rawProducts.map(p => {
      const offers = isInternalSession.value ? p.internalOffers : p.horanetOffers;
      return {
        ...p,
        dynamo_offers: Array.isArray(offers) ? offers : []
      };
    });

    store.commit('setSessionsCodes', codes.split(','));
    store.commit('setProducts', products);
    store.commit('setErrorMessage', message || null);
    return products;
  }

  try {
    const list = await getSessionProducts({
      workspace: workspace,
      activities: activities,
      sessions: codes,
      start_time: start_time,
      end_time: end_time
    });
    const products = list.map(p => ({
      ...p,
      dynamo_offers: Array.isArray(p.dynamo_offers) ? p.dynamo_offers : []
    }));
    store.commit('setSessionsCodes', codes.split(','));
    store.commit('setProducts', products);
    return products;
  } catch (err) {
    console.log('Error getting session products', err);
    store.commit('setLoading', false);
    store.commit('setError', JSON.stringify(err.message, null, 4));
    return [];
  }
};

const buildSessionDetails = sessionInfo => ({
  ...sessionInfo,
  start_date: parseInt(format(fromUnixTime(sessionInfo.start_time), 'T')),
  end_date: parseInt(format(fromUnixTime(sessionInfo.end_time), 'T')),
  detail: sessionInfo
});

const getCourtSettingsFromShoppingCart = (courtShoppingCart, sessionInfo, refresh) => ({
  ...store.state.courtSettings,
  haveGymLibCode: courtShoppingCart?.haveGymLibCode,
  promoCode: courtShoppingCart?.promoCode,
  haveSubscription: courtShoppingCart?.haveSubscription,
  isCaptainPlaying: sessionInfo?.captain?.isPlaying || courtShoppingCart.reservationInfo.isPlaying,
  tariff: {
    category: courtShoppingCart?.details?.priceCategory,
    tariffCode: courtShoppingCart?.details?.tariffCode,
    tariffCategoryCode: courtShoppingCart?.details?.tariffCategoryCode,
    price: courtShoppingCart?.details?.price,
    tva: courtShoppingCart?.details?.tva
  },
  selectedOptions: courtShoppingCart.options ? [...courtShoppingCart.options] : [],
  negotiatedPrice: courtShoppingCart?.details?.negotiatedPrice,
  partsQuantity: courtShoppingCart?.details?.quantity || store.state.courtSettings.partsQuantity || 1,
  currentStep: refresh === 'true' ? 'CourtPayment' : store.state.courtSettings.currentStep,
  refresh: refresh === 'true'
});

const loadCourtSessionInfo = async sessionId => {
  const sessionInfo = await getSessionById(sessionId, isInternalSession.value);
  return {
    sessionInfo,
    sessionDetails: buildSessionDetails(sessionInfo)
  };
};

onBeforeMount(async () => {
  const isCbReturn = route?.query?.refresh === 'true';
  const courtSettingsSnapshot = isCbReturn ? { ...store.state.courtSettings } : null;

  // If we detect it's a "new offer", we reset the state, before checking logged user
  cleanStateIfHome();

  if (isCbReturn) {
    store.commit('setCourtSettings', { ...courtSettingsSnapshot, currentStep: 'CourtPayment', refresh: true });
  }

  store.commit('setLoading', true);
  store.commit('setImpersonateData', route.query.impersonateData || store.state.impersonateData);

  // Handle Site in "Maintenance"
  handleMaintenance();

  // Coupe File routes have their own auth-free initialization process
  const base = process.env.BASE_URL || '/loisirs-reservation/';
  const pathWithoutBase = window.location.pathname.replace(base, '/').replace('//', '/');
  const resolvedRoute = router.resolve(pathWithoutBase);
  if (['CoupeFileTDA', 'CoupeFileConfirmation'].includes(resolvedRoute.name)) {
    loaded.value = true;
    store.commit('setLoading', false);
    return;
  }

  // Sync logged user (login-required responses include loginUrl; redirect is handled in makeApiRequest)
  const userResponse = await getUser();
  if (userResponse && userResponse.loginUrl) {
    return;
  }
  store.commit('setUser', userResponse.data);

  if (!allowedInitialRoute.value
      && !isInitializeRoute.value
      && !store.state.product
      && !store.state.siteInfo
  ) {
    // If it's not a initialize route and we don't have any product in the store
    // alert('Initialize route without product state');
    moveTo404();
    return;
  }

  if (isInitializeRoute.value) {
    const { workspace } = store.getters;
    // Both case get product and find OfferInfo - commit on Store, all App can look for product and offerInfo property
    let { product, offer } = route.query;
    const { user, order, session, contractToRecharge, activities, codes, start_time, end_time, page_url } = route.query;

    store.commit('setPageUrl', page_url);
    store.commit('setCourtSettings', { ...store.state.courtSettings, routeQueryActivities: activities });

    switch (route.name) {
      case 'CartRecap': {
        const cartItem = store.state.user?.shoppingCart?.find(
          item => item.workspace === workspace
        );
        if (cartItem) {
          product = cartItem.details[0].product_uuid;
          offer = cartItem.details[0].horanet_product_code;
        }
        store.commit(
          'addCartItemToCart',
          store.state.user?.shoppingCart
        );
        store.commit('setCartItem', {
          workspace: cartItem.workspace,
          participants: cartItem.details.map(detail => {
            const { __typename, ...participant } = detail.participant;
            return {
              ...participant,
              quantity: detail.quantity,
              tariff: { price: detail.price },
              options: detail.options
            };
          })
        });
        break;
      }
      case 'Home': {
        if (order) {
          const orderGeneric = await getOrderByUuid(order)
            .then(async response => response.order)
            .catch(() => null);
          store.commit('setOrder', orderGeneric);
        }
        if (user) {
          const selectedUser = store.state.user.uuid === user
            ? store.state.user
            : store.state.user.contacts.find(
              contact => contact.uuid === user
            );
          if (selectedUser) {
            store.commit('setCurrentParticipant', selectedUser);
            const productOfferOk = await handleProductAndOffer(product, offer);
            if (!productOfferOk) {
              loaded.value = true;
              moveTo404();
              return;
            }
            if (store.getters['expressCheckout/isActive']) {
              changeToPage('CoupeFileTDA');
            } else {
              removeCartAndChangePage(
                `${store.state.newTDA ? 'NewTDA' : ''}Tariffs`,
                [product]
              );
            }
            if (contractToRecharge) {
              store.commit('setContractToRecharge', contractToRecharge);
            }
          }
        } else {
          const productOfferOk = await handleProductAndOffer(product, offer);
          if (!productOfferOk) {
            loaded.value = true;
            moveTo404();
            return;
          }
          if (store.getters['expressCheckout/isActive']) {
            changeToPage('CoupeFileTDA');
          } else if (store.state.newTDA) {
            if (isSubscriptionTDA.value) {
              removeCartAndChangePage('NewTDARecurring', [product]);
            } else {
              removeCartAndChangePage('NewTDA', [product]);
            }
          } else if (store.state.offerInfo?.detail?.reservation && isImprovesWorkspace.value && store.state.offerInfo?.productType === 'terrain' && siteInfo.value.enableCourtProject) {
            const courtShoppingCart = store.state.user?.courtShoppingCart;
            const { refresh, invite } = route?.query;
            if (session || (courtShoppingCart?.sessionId && refresh === 'true')) {
              // get session and store it on store
              const id = session || courtShoppingCart?.sessionId;
              const { sessionInfo, sessionDetails } = await loadCourtSessionInfo(id);
              const sessionProductReference = await getServicesProduct([...new Set(sessionInfo.products)]);

              const doesSessionHaveCaptain = !!sessionInfo.captain;

              if (refresh === 'true' && courtShoppingCart) {
                store.commit('setCourtSettings', getCourtSettingsFromShoppingCart(courtShoppingCart, sessionInfo, refresh));
              }

              // todo:
              /*
                - validate if session is available
                  - session didn't start yet
                  - session have stock
                  - if the captain still on the session
              */
              const isValidSession = isSessionValid(sessionInfo, invite);

              store.commit('setCourtSettings', { ...store.state.courtSettings, session: sessionDetails, isInvite: doesSessionHaveCaptain, sessionServices: sessionProductReference, isValidSession });
            }

            removeCartAndChangePage('CourtReservation', [product]);
          } else {
            removeCartAndChangePage('Configure', [product]);
          }
        }
        break;
      }
      case 'Products': {
        const products = await handleActivitiesAndSession(
          workspace,
          activities,
          codes,
          start_time,
          end_time
        );

        const productsIds = products.map(p => p.uuid);

        const haveTerrainProduct = products.some(p => p.dynamo_offers.some(o => o.productType === 'terrain'));

        const { refresh, invite } = route?.query;
        const courtShoppingCart = store.state.user?.courtShoppingCart;
        if (isImprovesWorkspace.value && haveTerrainProduct && siteInfo.value.enableCourtProject && refresh === 'true' && courtShoppingCart) {
          const { sessionInfo, sessionDetails } = await loadCourtSessionInfo(courtShoppingCart.sessionId);
          const isValidSession = isSessionValid(sessionInfo, invite);

          store.commit('setCourtSettings', {
            ...getCourtSettingsFromShoppingCart(courtShoppingCart, sessionInfo, refresh),
            isInvite: invite === 'true',
            session: sessionDetails,
            isValidSession
          });
        }

        if (products.length === 1) {
          if ((products[0].areas || []).some(a => a.showMultipleOffers)) {
            const selectedProduct = products[0].uuid;
            const handleProductResponse = await handleEscapeProduct(
              selectedProduct
            );

            if (!handleProductResponse) {
              loaded.value = true;
              moveTo404();
              return;
            }
            removeCartAndChangePage('OfferList', [selectedProduct]);
          } else if (products[0].dynamo_offers.length === 1) {
            const selectedProduct = products[0].uuid;
            const selectedOffer = store.state.siteInfo
                && store.state.siteInfo.is_internal_session
              ? products[0].dynamo_offers[0].uuid
              : products[0].dynamo_offers[0].horanet_product
                .horanet_product_code;

            const handleProductResponse = await handleProduct(
              selectedProduct,
              selectedOffer
            );

            if (!handleProductResponse) {
              loaded.value = true;
              moveTo404();
              return;
            }

            const reddirectTo = isImprovesWorkspace.value && haveTerrainProduct && siteInfo.value.enableCourtProject ? 'CourtReservation' : 'Terrain';
            removeCartAndChangePage(reddirectTo, productsIds);
          } else {
            const reddirectTo = isImprovesWorkspace.value && haveTerrainProduct && siteInfo.value.enableCourtProject ? 'CourtReservation' : 'Products';
            removeCartAndChangePage(reddirectTo, productsIds);
          }
        } else {
          const reddirectTo = isImprovesWorkspace.value && haveTerrainProduct && siteInfo.value.enableCourtProject ? 'CourtReservation' : 'Products';
          removeCartAndChangePage(reddirectTo, productsIds);
        }
        break;
      }
      default:
        moveTo404();
        return;
    }
  } else if (route.name === 'Home') {
    moveTo404();
    return;
  }

  loaded.value = true;
  store.commit('setLoading', false);
});

</script>

<style>
header {
  height: 100px;
}

.cart-body {
  height: calc(100vh - 100px);
}

.logo-container {
  width: 37.5%;
}

.ucpa-logo {
  fill: #000000;
  width: 100px;
  height: 100px;
}

.bg-image {
  background-repeat: no-repeat;
  background-position-x: 50%;
  background-position-y: 0;
  background-origin: border-box;
  background-size: cover;
}
.ucpa-Cart-top {
  height: 9.375rem;
}

.ucpa-CartHeader-logo {
  display: block;
  width: 5rem;
  color: #1a1a1a;
}

#left-block {
  width: 37.5%;
}

#right-block {
  width: 62.5%;
}

.body-pd {
  padding: 0 3rem;
}

.step-position {
  align-items: center;
}

@media screen and (max-width: 64rem) {
  .body-pd {
    padding: 0 1rem;
  }

  #left-block {
    width: 0%;
  }

  #right-block {
    width: 100%;
  }
}
@media screen and (max-width: 40rem) {
  .step-position {
    align-items: flex-end;
  }
  header {
    height: 60px;
  }

  .cart-body {
    height: calc(100dvh - 60px);
  }
}
</style>
